export enum GenderTypes {
  None = 0,
  Male = 1,
  Female = 2,
}

export function getGenderTypeName(value: GenderTypes): string {
  switch (value) {
    case GenderTypes.None: return '不明';
    case GenderTypes.Male: return '男性';
    case GenderTypes.Female: return '女性';
  }
}
